// The theming package provides theming assets only
import "./generated/json-imports/Themes-fetch.js";
